import { Alert } from "antd";

const AlertWizz = (props) => {
  return <Alert {...props} />;
};

export default AlertWizz;
